type Props = { width?: number; height?: number; fill?: string };

const PalommaLogo = ({ width = 29, height = 28, fill = "#4012AB" }: Props): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M27.2408 15.2447C27.2408 15.2447 28.7874 12.5441 28.1725 10.578C28.1472 10.4955 28.1186 10.4163 28.0916 10.3371C28.0647 10.2613 28.036 10.1872 28.0057 10.113C27.2914 8.3744 25.6016 7.23215 23.7265 7.10748L21.4117 6.95417L21.2584 4.63935C21.1337 2.76424 19.9914 1.07445 18.2528 0.360125C18.1787 0.3298 18.1045 0.301159 18.0287 0.274204C17.9495 0.247248 17.8704 0.218607 17.7878 0.193336C15.8217 -0.421592 13.1211 1.12499 13.1211 1.12499L0.365967 7.79991C1.53012 9.98164 4.17347 10.8745 6.40742 9.88561C6.44786 9.97659 6.48997 10.0659 6.53715 10.1552C7.70972 12.3975 10.439 13.2972 12.7066 12.224C12.8111 13.0613 13.1817 13.8717 13.8236 14.5136C14.4655 15.1555 15.3011 15.5379 16.1519 15.6356C15.0619 17.9083 15.9615 20.6511 18.2107 21.8287C18.3 21.8759 18.3892 21.918 18.4802 21.9584C17.4913 24.1907 18.3842 26.8357 20.5659 27.9999L27.2408 15.2447Z"
        fill={fill}
      />
    </svg>
  );
};

export default PalommaLogo;
